import { createFileRoute, notFound } from '@tanstack/react-router';
import { NotFoundPage } from './-components/not-found';

export const Route = createFileRoute('/new/$')({
	// A 404 answering 200 is a soft 404: search engines index it as a real page and the site
	// accumulates duplicates of it.
	//
	// This used to call `setResponseStatus(404)` from `@tanstack/react-start/server`, which is DEAD CODE
	// on an SSR document render and had been since TEC-3629 shipped it — `new.worldcoo.com/nope` was
	// answering 200 in production. That helper writes `event.res.status` on the h3 event, but h3's
	// `prepareResponse` only consults the event's status on the branch where the handler returned
	// something that is NOT already a `Response`; the SSR stream handler always returns a real one, so
	// the event's status is dropped on the floor. The status of an HTML render comes from
	// `router.stores.statusCode`, which `renderRouterToStream` reads.
	//
	// `notFound()` thrown from a LOADER is what sets that store (`hasNotFoundMatch()` → 404). It does
	// not contradict the rule below: that rule is about a RENDER-phase throw, which is a different
	// thing entirely, and this route still renders its component rather than throwing inside it.
	loader: () => {
		throw notFound();
	},
	// The same page on both paths. The throw above routes to the nearest `notFoundComponent`, and `/new`
	// declares one — but naming it here too keeps this route's 404 answerable from this file rather than
	// depending on a parent that could stop declaring one.
	notFoundComponent: NotFoundPage,
	// Rendered, not `throw notFound()` INSIDE the component: on SSR streaming React treats a render-phase
	// throw as an uncaught error and switches the whole tree to client rendering. $portalId/route.tsx
	// documents the same trap.
	component: NotFoundPage,
});
